const initialState = {
    loadingOperationDashboardCount: false,
    operationDashboardCountError: "",
    operationDashboardCount: null,
};

const OperationsDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FIND_OPERATION_DASHBOARD_COUNT_REQUEST":
            return {
                ...state,
                loadingOperationDashboardCount: true,
                operationDashboardCountError: "",
            };
        case "FIND_OPERATION_DASHBOARD_COUNT_SUCCESS":
            return {
                ...state,
                loadingOperationDashboardCount: false,
                operationDashboardCount: action.payload,
                operationDashboardCountError: "",
            };
        case "FIND_OPERATION_DASHBOARD_COUNT_FAILURE":
            return {
                ...state,
                loadingOperationDashboardCount: false,
                operationDashboardCountError: action.payload,
            };
        default:
            return state;
    }
};

export default OperationsDashboardReducer;
